module.exports = __webpack_public_path__ + "static/media/NOTRE POLITIQUE DE PROTECTION DES DONNÉES À CARACTÈRE PERSONNEL.8a31a8d4.pdf";